import React from 'react';
import { Button } from 'antd';
import { WhatsAppOutlined, MessageFilled } from '@ant-design/icons';

const WhatsAppBanner = () => {

    let user_detail = {};
    try {
        user_detail = JSON.parse(localStorage.getItem("userData")) || {};
    } catch (e) {
        console.error("Error parsing userData", e);
    }

    const email = user_detail.emailid || user_detail.email || "";
    const username = user_detail.username || user_detail.name || "";

    return (
        <div
            style={{
                background: "linear-gradient(135deg, #075e54 0%, #128c7e 50%, #25d366 100%)",
                borderRadius: "16px",
                padding: "24px 30px",
                marginBottom: "20px",
                marginTop: "20px",
                color: "white",
                boxShadow: "0 8px 20px rgba(18, 140, 126, 0.25)",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: "16px",
                position: "relative",
                overflow: "hidden"
            }}
        >
            {/* Decorative Circles */}
            <div style={{
                position: "absolute",
                top: "-20px",
                right: "-20px",
                width: "100px",
                height: "100px",
                background: "rgba(255,255,255,0.1)",
                borderRadius: "50%",
                pointerEvents: "none"
            }}></div>

            <div style={{ flex: 1, minWidth: "200px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
                    <MessageFilled style={{ fontSize: "24px", color: "rgba(255,255,255,0.9)" }} />
                    <h2 style={{ margin: 0, color: "white", fontSize: "20px", fontWeight: "700" }}>Need quick help?</h2>
                </div>
                <p style={{ margin: 0, color: "rgba(255,255,255,0.9)", fontSize: "14px", lineHeight: "1.5" }}>
                    Talk with our team for instant support and strategy guidance.
                </p>
            </div>

            <Button
                type="primary"
                size="large"
                icon={<WhatsAppOutlined />}
                style={{
                    background: "white",
                    color: "#075e54",
                    border: "none",
                    fontWeight: "600",
                    height: "45px",
                    padding: "0 24px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    display: "flex", alignItems: "center", gap: "8px"
                }}
                onClick={() => {
                    const message = `Quick support for instantdm, \nEmail: ${email} \nUsername: ${username}`;
                    const encodedMessage = encodeURIComponent(message);
                    window.open(`https://wa.me/918903401690?text=${encodedMessage}`, '_blank');
                }}
            >
                Talk with our Team
            </Button>
        </div>
    );
};

export default WhatsAppBanner;
